import { Switch as BaseSwitch } from "@base-ui/react/switch";
import type { ComponentProps } from "react";
import { cn } from "../utils";

export function Switch({
  className,
  ...props
}: ComponentProps<typeof BaseSwitch.Root>) {
  return (
    <BaseSwitch.Root
      className={cn(
        "relative inline-flex h-5 w-8 shrink-0 cursor-pointer items-center rounded-full",
        "bg-line-strong shadow-raised",
        "transition-[background-color,box-shadow,transform] duration-150 ease-swift",
        "data-checked:bg-ember",
        "active:scale-[0.97]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ember/25",
        "disabled:pointer-events-none disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <BaseSwitch.Thumb
        className={cn(
          "block size-3.5 translate-x-0.5 rounded-full bg-surface-raised shadow-raised",
          "transition-transform duration-150 ease-swift",
          "data-checked:translate-x-[0.875rem]",
        )}
      />
    </BaseSwitch.Root>
  );
}
